module.exports = __webpack_public_path__ + "img/KhalilAbdula-ChrakaniNishtiman.b87860ac.jpg";